import { jsxs as e, jsx as l } from "react/jsx-runtime";
const i = (a) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...a,
    children: [
      /* @__PURE__ */ l(
        "mask",
        {
          id: "click_svg__a",
          width: 20,
          height: 20,
          x: 2,
          y: 2,
          maskUnits: "userSpaceOnUse",
          style: {
            maskType: "alpha"
          },
          children: /* @__PURE__ */ l(
            "path",
            {
              fill: "currentcolor",
              fillRule: "evenodd",
              d: "M13 3a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0zM3 11a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm1.893-6.107a1 1 0 0 1 1.414 0l2.2 2.2a1 1 0 1 1-1.414 1.414l-2.2-2.2a1 1 0 0 1 0-1.414m14.214 1.414a1 1 0 0 0-1.414-1.414l-2.2 2.2a1 1 0 0 0 1.414 1.414zm-10.6 9.186a1 1 0 0 1 0 1.414l-2.2 2.2a1 1 0 0 1-1.414-1.414l2.2-2.2a1 1 0 0 1 1.414 0m3.81-4.442a1 1 0 0 0-1.266 1.265l3 9a1 1 0 0 0 1.843.131l1.851-3.702 3.702-1.85a1 1 0 0 0-.13-1.844zm2.868 7.342-1.604-4.812 4.812 1.604-1.84.92a1 1 0 0 0-.447.448z",
              clipRule: "evenodd"
            }
          )
        }
      ),
      /* @__PURE__ */ l("g", { mask: "url(#click_svg__a)", children: /* @__PURE__ */ l("path", { fill: "currentcolor", d: "M0 0h24v24H0z" }) })
    ]
  }
);
export {
  i as default
};
